'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkUnicodeText = exports.filterText = exports.replaceUnicode = exports.checkIsEmpty = exports.lodash = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lodash = exports.lodash = _lodash2.default;

var checkIsEmpty = exports.checkIsEmpty = function checkIsEmpty(val) {
    if (val === null || val === undefined || val === '') {
        return true;
    } else if (_lodash2.default.isObject(val) || _lodash2.default.isArray(val)) {
        return _lodash2.default.isEmpty(val);
    }
    return _lodash2.default.isEmpty(val.toString());
};

var replaceUnicode = exports.replaceUnicode = function replaceUnicode(str) {
    if (str === null) {
        return '';
    }
    str = str.toLowerCase();
    str = str.replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, 'a');
    str = str.replace(/[èéẹẻẽêềếệểễ]/g, 'e');
    str = str.replace(/[ìíịỉĩ]/g, 'i');
    str = str.replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, 'o');
    str = str.replace(/[ùúụủũưừứựửữ]/g, 'u');
    str = str.replace(/[ỳýỵỷỹ]/g, 'y');
    str = str.replace(/đ/g, 'd');
    return str.trim();
};

var filterText = exports.filterText = function filterText(array, text, fields) {
    var searchString = replaceUnicode(text);
    var regExp = new RegExp(searchString, 'i');
    var found = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var field = _step.value;

            var result = _lodash2.default.filter(array || [], function (item) {
                return regExp.test(replaceUnicode(item.hasOwnProperty(field) ? item[field] : ''));
            });
            found = _lodash2.default.union(found, result);
        };

        for (var _iterator = (0, _getIterator3.default)(fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return found;
};

var checkUnicodeText = exports.checkUnicodeText = function checkUnicodeText(str) {
    var regex = /à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ|è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ|ì|í|ị|ỉ|ĩ|ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ|ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ|ỳ|ý|ỵ|ỷ|ỹ|đ/g;
    return regex.test(str);
};